function getInitials(name) {
  return name.trim().split(" ").reduce((initials, name2, index, array) => {
    if (index === 0 || index === array.length - 1) {
      initials += name2.charAt(0).toLocaleUpperCase();
    }
    return initials;
  }, "");
}

export { getInitials };
//# sourceMappingURL=get-initials.js.map
